// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, object } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import AuthContext from './AuthContext'
import ReactGA from 'react-ga4'
import { validateUser } from './helpers'

import {
  measurementId,
  trackingConfig,
} from 'constants/userPool'

// need to point directly to it since the Auth stuff is exported first in components/index.js
import LoadingIcon from 'components/LoadingIcon'

class AuthProvider extends React.Component {
  static propTypes = {
    children: object.isRequired,
    validateUser: func.isRequired,
  }

  state = {
    groups: [],
    isLoading: true,
    user: null,
    GA_userId: null, // this is the uid which will be sent to Google Analytics
  }

  async componentDidMount () {
    // initialize the GA tracker based on the user pool
    ReactGA.initialize(measurementId, trackingConfig)

    await this.updateAuthState()
  }

  // triggers Amplify to get and set user data so we can expose it within React.
  updateAuthState = async () => {
    const {
      GA_userId,
      groups,
      user,
    } = await this.props.validateUser()

    if (this.state.user !== null && user === null) {
      window.location.reload()
    }

    // clear out the stored user
    this.setState(() => ({
      groups,
      isLoading: false,
      user,
      GA_userId,
    }))
  }

  render () {
    const {
      state: {
        // there's no reason to pass isLoading here to a child.
        isLoading,
        ...state
      },
      updateAuthState,
    } = this

    return (
      isLoading
        ? <LoadingIcon isLoading={true} />
        : (
          <AuthContext.Provider
            value={{
              ...state,
              updateAuthState,
            }}>
            {this.props.children}
          </AuthContext.Provider>
        )
    )
  }
}

// no need to pull anything from state here
const mapStateToProps = (state, props) => ({})

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    validateUser,
  }, dispatch)
)

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AuthProvider)
